import type { AxiosError } from 'axios';
import type { QueryKey, UseQueryOptions } from '@tanstack/react-query';

/**
 * Local mirror of v5's `queryOptions()` helper.
 *
 * Purpose: catch v5-only option names (`gcTime`, etc.) at compile time via
 * excess-property check on the literal. The check only fires because the
 * parameter is typed as a fixed `UseQueryOptions<...>` shape, not as a generic
 * constraint — generic constraints don't trigger excess-property checks.
 *
 * On the v4 → v5 migration this is a one-line import swap:
 *   from 'services/query'  →  from '@tanstack/react-query'
 *
 * `TError` defaults to `AxiosError` to align with `useApiMutation`.
 */
export const queryOptions = <
  TQueryFnData,
  TError = AxiosError,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey,
>(
  options: UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>,
): UseQueryOptions<TQueryFnData, TError, TData, TQueryKey> => options;
